import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { CDN_URL, formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch, MdArrowForward } from "react-icons/md";

export default function OneService({ data }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ isHovered, setIsHovered ] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'news',
      extraItem: data.uuid,
    })
  }
const formatDate = (value) => {
  if (!value) return '';

  let timestamp = Number(value);

  // Detect seconds vs milliseconds
  if (timestamp < 1e12) {
    timestamp *= 1000; // convert seconds → ms
  }

  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  return new Date(timestamp).toLocaleDateString('en-US', options);
};
  
  return (
    <div 
      className="card border-0 shadow-sm"
      style={{
        height: "420px",
        cursor: "pointer",
        backgroundImage: `url(${CDN_URL + data.coverPhoto})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        overflow: "hidden",
        marginBottom: "24px",
        borderRadius: "12px",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        transform: isHovered ? "translateY(-6px)" : "translateY(0)",
        boxShadow: isHovered 
          ? "0 10px 20px rgba(0,0,0,0.15)" 
          : "0 4px 8px rgba(0,0,0,0.08)"
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        view();
      }}
    >
      
      {/* Gradient Overlay - Enhanced for readability */}
      <div
        className="rounded"
        style={{
          width: "100%",
          height: "100%",
          background: "linear-gradient(to top, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.7) 40%, rgba(15,23,42,0.3) 70%, transparent 100%)",
          position: "absolute",
          top: 0,
          left: 0,
          transition: "opacity 0.3s ease",
          overflow: "hidden"

        }}
      >
        {/* Subtle animated accent line */}
        <div 
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: isHovered ? "100%" : "60px",
            height: "3px",
            background: "linear-gradient(90deg, #3b82f6, #6366f1)",
            transition: "width 0.4s ease"
          }}
        />
      </div>


      {/* Content Area */}
      <div 
        style={{
          width: "100%",
          position: "absolute",
          padding: "24px",
          bottom: 0,
          left: 0,
          zIndex: 3,
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}
      >
        
        {/* Date */}
        {data.dateCreated && (
          <span 
            style={{
              fontSize: "0.8rem",
              color: "rgba(255,255,255,0.85)",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            <span style={{ width: "4px", height: "4px", borderRadius: "50%", background: "#60a5fa" }} />
            {formatDate(data.dateCreated)}
          </span>
        )}

        {/* Title */}
        <h6
          style={{
            fontSize: "1.25rem",
            lineHeight: "1.4",
            fontWeight: "700",
            color: "#ffffff",
            margin: 0,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            textShadow: "0 2px 4px rgba(0,0,0,0.3)",
          }}
          className="mNoMargin"
        >
          {data.title}
        </h6>


        {/* Read More Indicator */}
        <div 
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "4px",
            paddingTop: "8px",
            borderTop: "1px solid rgba(255,255,255,0.2)"
          }}
        >
          <span 
            className="mt-2"
            style={{
              fontSize: "0.85rem",
              fontWeight: "600",
              color: "#ffffff",
              letterSpacing: "0.5px"
            }}
          >
            Read Insight
          </span>
          <MdArrowForward 
            size={18} 
            color="#ffffff" 
            style={{ 
              transition: "transform 0.3s ease, opacity 0.3s ease",
              transform: isHovered ? "translateX(4px)" : "translateX(0)",
              opacity: isHovered ? 1 : 0.9
            }} 
          />
        </div>

      </div>

      {/* Subtle hover overlay enhancement */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(15,23,42,0.1)",
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
          zIndex: 1
        }}
      />
    </div>
  )
}
